module.exports = __webpack_public_path__ + "e2a607f2305d77bccd034a478c63f3c6.png";